import { useState, useEffect } from "react";
import { PaziaModal } from "components/molecules";
import { ModalHeader } from "components/templates/Modals/ModalHeader";
import { ModalPadding } from "components/templates/Modals/ModalPadding";
import { PaziaButton } from "components/atoms";

interface RowSettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  gap: number;
  marginTop: number;
  marginBottom: number;
  onSave: (gap: number, marginTop: number, marginBottom: number) => void;
}

export const RowSettingsModal = ({
  isOpen,
  onClose,
  gap: initialGap,
  marginTop: initialMarginTop,
  marginBottom: initialMarginBottom,
  onSave,
}: RowSettingsModalProps) => {
  const [gap, setGap] = useState(initialGap);
  const [marginTop, setMarginTop] = useState(initialMarginTop);
  const [marginBottom, setMarginBottom] = useState(initialMarginBottom);

  useEffect(() => {
    setGap(initialGap);
  }, [initialGap]);

  useEffect(() => {
    setMarginTop(initialMarginTop);
  }, [initialMarginTop]);

  useEffect(() => {
    setMarginBottom(initialMarginBottom);
  }, [initialMarginBottom]);

  const handleSave = () => {
    onSave(gap, marginTop, marginBottom);
    onClose();
  };

  return (
    <PaziaModal id="row-settings-modal" onCloseRequest={onClose} isOpen={isOpen} size="sm">
      {isOpen && (
        <ModalPadding>
          <ModalHeader>Ustawienia wiersza</ModalHeader>
          <div className="mt-4 space-y-4">
            <div>
              <label className="mb-1.5 block text-sm font-medium text-slate-700 dark:text-slate-300">
                Odstęp między kolumnami (px)
              </label>
              <input
                type="number"
                min={0}
                max={100}
                step={4}
                value={gap}
                onChange={(e) => setGap(Number(e.target.value))}
                className="w-24 rounded-md border border-slate-300 px-2 py-1.5 text-sm dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200"
              />
            </div>

            <div>
              <label className="mb-1.5 block text-sm font-medium text-slate-700 dark:text-slate-300">
                Margines górny (px)
              </label>
              <input
                type="number"
                min={0}
                max={200}
                step={4}
                value={marginTop}
                onChange={(e) => setMarginTop(Number(e.target.value))}
                className="w-24 rounded-md border border-slate-300 px-2 py-1.5 text-sm dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200"
              />
            </div>

            <div>
              <label className="mb-1.5 block text-sm font-medium text-slate-700 dark:text-slate-300">
                Margines dolny (px)
              </label>
              <input
                type="number"
                min={0}
                max={200}
                step={4}
                value={marginBottom}
                onChange={(e) => setMarginBottom(Number(e.target.value))}
                className="w-24 rounded-md border border-slate-300 px-2 py-1.5 text-sm dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200"
              />
            </div>

            <div className="flex justify-end gap-2 border-t border-slate-200 pt-4 dark:border-slate-700">
              <button
                type="button"
                onClick={onClose}
                className="rounded-lg border border-slate-300 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700"
              >
                Anuluj
              </button>
              <PaziaButton type="success" title="Zapisz" onClick={handleSave} />
            </div>
          </div>
        </ModalPadding>
      )}
    </PaziaModal>
  );
};
